import React, { useMemo, useRef } from 'react';
import { useSelector } from 'react-redux';

import { UnidataTable } from '~/components';
import { t } from '~/helpers';
import { formatISO } from '~/helpers/dateTime';
import { handleExportGeneric } from '~/helpers/exportReports';
import { recordFiltering } from '~/store/modules/operacaodiagnostico/actions';

function OperacaoDiagnostico() {
  const redux = useSelector((state) => state.operacaodiagnostico);

  const header = useMemo(
    () => [
      {
        id: 'nomeabreviadoposto',
        label: t('s.geral.postocomboio'),
        filter: {
          type: 'text',
        },
      },
      {
        id: 'idterminal',
        label: t('s.menu.configuracao.terminal'),
        filter: {
          type: 'text',
        },
      },
      {
        id: 'ipterminal',
        label: t('s.menu.operacao.resumointerfaceterminal.ipterminal'),
        filter: {
          type: 'text',
        },
      },
      {
        id: 'iplocalterminal',
        label: t('s.geral.iplocal'),
        filter: {
          type: 'text',
        },
      },
      {
        id: 'versaofirmwareterminal',
        label: t('s.geral.camposistema.versaofirmwareterminal'),
        filter: {
          type: 'text',
        },
      },
      {
        id: 'modeloterminal',
        label: t('s.menu.cadastro.veiculo.modelo'),
        filter: {
          type: 'text',
        },
      },
      {
        id: 'regsinterfaceterminal',
        label: t('s.menu.operacao.resumointerfaceterminal.regspendentes'),
      },
      {
        id: 'versaotelemetriaterminal',
        label: t('s.geral.versaotelemetriaterminal'),
        filter: {
          type: 'text',
        },
      },
      {
        id: 'buildtelemetriaterminal',
        label: t('s.geral.buildtelemetriaterminal'),
      },
      {
        id: 'dataultimaconexaoterminal',
        label: t('c.menu.stock.ultimacomunicacao'),
        formatted: (date) => formatISO({ date }),
      },
    ],
    []
  );

  const fieldlist = [
    'nomeabreviadoposto',
    'idterminal',
    'ipterminal',
    'iplocalterminal',
    'versaofirmwareterminal',
    'modeloterminal',
    'regsinterfaceterminal',
    'versaotelemetriaterminal',
    'buildtelemetriaterminal',
    'dataultimaconexaoterminal',
  ];

  const substituirHeader = {
    nomeabreviadoposto: t('s.geral.postocomboio'),
    idterminal: t('s.menu.configuracao.terminal'),
    ipterminal: t('s.menu.operacao.resumointerfaceterminal.ipterminal'),
    iplocalterminal: t('s.geral.iplocal'),
    versaofirmwareterminal: t('s.geral.camposistema.versaofirmwareterminal'),
    modeloterminal: t('s.menu.cadastro.veiculo.modelo'),
    regsinterfaceterminal: t(
      's.menu.operacao.resumointerfaceterminal.regspendentes'
    ),
    versaotelemetriaterminal: t('s.geral.versaotelemetriaterminal'),
    buildtelemetriaterminal: t('s.geral.buildtelemetriaterminal'),
    dataultimaconexaoterminal: t('c.menu.stock.ultimacomunicacao'),
  };

  return (
    <UnidataTable
      fixed
      redux={redux}
      header={header}
      read={recordFiltering}
      update={false}
      delete={false}
      actions={[]}
      pdf
      excel
      onExport={(formato) =>
        handleExportGeneric({
          endpoint: 'resumosinterfacesterminais',
          formato,
          fields: fieldlist,
          headers: substituirHeader,
          redux,
          ordination: redux.params.ordination,
          orderfield: redux.params.orderfield,
          title: 'Relatório de Diagnóstico',
        })
      }
    />
  );
}

export default OperacaoDiagnostico;
